export default __webpack_public_path__ + "static/media/btndownloadicon.56738d46.svg";